import { render } from "./FormAttributePenyusunan.vue?vue&type=template&id=0bf2e0e3"
import script from "./FormAttributePenyusunan.vue?vue&type=script&lang=js"
export * from "./FormAttributePenyusunan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__